export const LANGUAGE_LABELS: { [key: string]: string } = {
    'en': 'English',
    'ja': '日本語',
    'vi': 'Tiếng Việt',
};